import React from 'react';
import StatsSection from './StatsSection';


const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="me-2">
    <path d="M5 20V19C5 17.1435 5.7375 15.363 7.05025 14.0503C8.36301 12.7375 10.1435 12 12 12M12 12C13.8565 12 15.637 12.7375 16.9497 14.0503C18.2625 15.363 19 17.1435 19 19V20M12 12C13.0609 12 14.0783 11.5786 14.8284 10.8284C15.5786 10.0783 16 9.06087 16 8C16 6.93913 15.5786 5.92172 14.8284 5.17157C14.0783 4.42143 13.0609 4 12 4C10.9391 4 9.92172 4.42143 9.17157 5.17157C8.42143 5.92172 8 6.93913 8 8C8 9.06087 8.42143 10.0783 9.17157 10.8284C9.92172 11.5786 10.9391 12 12 12Z" stroke="#F2CC00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const HeroSection = () => {
  return (
    <main className="new-demo-main-section container-fluid px-0">
      <div className="demo-content-container">
        <div className="row align-items-center justify-content-between mx-0 section-padding-1">
          <div className="col-12 col-lg-6 mb-5 mb-lg-0 new-demo-left-content position-relative text-center text-lg-start">
            <div className="glow-effect-bg"></div>
            <div className="new-demo-badge d-inline-flex align-items-center position-relative z-1 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none" className="new-demo-star-icon me-2">
                <path d="M11.5233 0C12.2469 8.74716 14.4302 10.6213 23 11.5159C14.1374 12.3766 12.4209 14.2592 11.5 23C10.6619 14.3355 8.72897 12.2791 0 11.5159C8.93902 10.4962 10.5219 8.87649 11.5255 0H11.5233Z" fill="#EDEDED" />
              </svg>
              AI-Powered Jewellery Photography
            </div>

            <h1 className="new-demo-heading position-relative z-1 mb-4">
              From Product to Photoshoot.<br className="d-none d-lg-block" />
              <span className="new-demo-highlight"> Instantly.</span>
            </h1>

            <p className="new-demo-description position-relative z-1 mb-4">
              Turn raw jewellery images into high-converting visuals
              using AI-powered model photography. Campaign-ready
              outputs for ads, PDP, and catalogs in seconds
            </p>

            <button
              onClick={() => {
                const element = document.getElementById('transformation-section');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="new-demo-showcase-btn position-relative z-1 d-inline-flex align-items-center justify-content-center mt-2"
            >
              View Showcase
            </button>
          </div>

          <div className="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end align-items-start position-relative">
            <div className="new-demo-image-cards d-flex flex-column flex-md-row gap-3 position-relative z-1">
              <div className="new-demo-card position-relative">
                <div className="new-demo-tag before-tag position-absolute top-0 start-0 m-3 z-3">BEFORE</div>
                <div className="new-demo-product-img-wrap">
                  <img src="/assets/demo/main_product_before.png" alt="Before" className="img-fluid new-demo-product-img" />
                </div>

                <div className="new-demo-floating-badge model-selection position-absolute d-flex align-items-center">
                  <UserIcon />
                  AI Model Selection
                </div>

                <div className="new-demo-floating-badge face-selection position-absolute d-flex align-items-center">
                  <UserIcon />
                  Custom Face Selection
                </div>
              </div>

              <div className="new-demo-card position-relative">
                <div className="new-demo-tag after-tag position-absolute top-0 end-0 m-3 z-3">AFTER.AI</div>
                <div className="new-demo-product-img-wrap">
                  <img src="/assets/demo/main_product_after.png" alt="After" className="img-fluid new-demo-product-img" />
                </div>

                <div className="new-demo-floating-badge clothing-selection position-absolute d-flex align-items-center">
                  <UserIcon />
                  Clothing Selection
                </div>
              </div>
            </div>
          </div>
        </div>

        <StatsSection />
      </div>
    </main>
  );
};

export default HeroSection;
